import classNames from 'classnames/bind';
import React, { useState, useEffect, forwardRef } from 'react';
import uniqid from 'uniqid';
import Plotly, { Config, Layout, PlotData } from 'plotly.js-basic-dist-min';
import { useWindowResizeListener } from '../../../../hooks/common';
import styles from './ChartPlotly.module.scss';

const cx = classNames.bind(styles);

export interface ChartPlotlyProps {
  data: PlotData;
  layout?: Layout;
  config?: Config;
  isFixedHeight?: boolean;
}

const ChartPlotly = forwardRef<HTMLDivElement, ChartPlotlyProps>(({ data, layout, config, isFixedHeight }, ref) => {
  const [id] = useState<string>(`fg_${uniqid()}`);

  useEffect(() => {
    if (id && data) {
      Plotly.newPlot(id, data, layout, config);
    }
  }, [id, data, layout, config]);

  const handleResize = () => {
    if (ref && 'current' in ref) {
      Plotly.relayout(ref.current, { autosize: true });
    }
  };

  useWindowResizeListener(handleResize);

  return <div className={isFixedHeight ? cx('body') : ''}>{id && data ? <div id={id} ref={ref} /> : null}</div>;
});

export default ChartPlotly;
